/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { Box, Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './OrDivider.styles';

interface OrDividerProps {
  text: React.ReactNode;
}

function OrDivider(props: OrDividerProps) {
  const { text } = props;
  const classes = useStyles();
  return (
    <Box my={1.5}>
      <Typography variant="body1" className={classes.orDividerText}>
        {text}
      </Typography>
    </Box>
  );
}

export default OrDivider;
